import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-647dd86e")
const _hoisted_1 = { class: "skeleton skeleton--image" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mask mask--dark" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}